module.exports = __webpack_public_path__ + "img/1495597712.206e1b2f.jpg";